import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=5c8b1a3c&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=5c8b1a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b1a3c",
  null
  
)

export default component.exports